export default "__VITE_ASSET__qtp6kcz2__";